const SEARCHDATA_KEY = 'search_phrase'

// Helper functions for sessionStorage
function getData (key: string) {
  // Get serialized data from sessionStorage
  if (sessionStorage.getItem(SEARCHDATA_KEY)) {
    const selectedFilters = JSON.parse(sessionStorage.getItem(SEARCHDATA_KEY) || '')
    return selectedFilters[key]

  // If data does not exist (yet), return default data
  } else {
    if (key === 'searchInSelection') {
      return false
    } else {
      return ''
    }
  }
}

function saveData () {
  sessionStorage.setItem(SEARCHDATA_KEY, JSON.stringify(
    {
      phrase: state.searchPhrase,
      searchInSelection: state.searchInSelection
    }
  ))
}

function resetData () {
  sessionStorage.removeItem(SEARCHDATA_KEY)
}

// initial state
const state = {
  searchInSelection: getData('searchInSelection'),
  searchPhrase: getData('phrase'),
  searchModalActive: false
}

// getters
const getters = {
  phrase: (state: any) => {
    return state.searchPhrase
  },
  options: (state: any) => {
    return state.searchPhrase
  }
}

// mutations
const mutations = {
  update: (state: any, value: string) => {
    state.searchPhrase = value
    saveData()
  },

  searchInSelection: (state:any, searchInSelection: boolean) => {
    state.searchInSelection = searchInSelection
    saveData()
  },

  updateSearchModal: (state: any, value: boolean) => {
    state.searchModalActive = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
